import { create } from 'zustand';
import type { Asset, AssetGroup, GroupType } from '@scio3/shared-types';

export type AssetDialogType =
  | 'createFolder'
  | 'rename'
  | 'editTags'
  | 'moveFolder'
  | 'remove'
  | 'getInfo'
  | 'pushToScreens'
  | 'addToPlaylist'
  | 'liveExpire'
  | 'replaceAsset'
  | 'editDescription'
  | 'preview'
  | 'playlistUsage'
  | 'confirmCreateAsset'
  | 'folderPermission'
  | 'duplicate'
  | 'feeds'
  | 'feedEdit'
  | 'assetDetail'
  | 'pageDurations'
  | null;

interface AssetDialogContext {
  asset?: Asset;
  assetIds?: string[];
  folder?: AssetGroup;
  folderIds?: string[];
  /** Team ID of selected folders (for bulk folder moves - filters target to same team) */
  selectedFoldersTeamId?: string;
  /** Folder group type for bulk delete (e.g. 'engage') when folder object is not available */
  folderType?: GroupType;
  /** When true, shows playlist prev/next navigation arrows in preview dialog */
  isPlaylist?: boolean;
  /** Override folder path (used when opened from asset picker in playlist page) */
  currentPath?: string;
  /** Force the asset detail view read-only — e.g. drive-app children (Google Drive /
   *  OneDrive / Dropbox) opened from a playlist cannot be renamed/tagged/deleted. */
  readOnly?: boolean;
}

interface AssetDialogState {
  activeDialog: AssetDialogType;
  dialogContext: AssetDialogContext;
  openDialog: (dialog: AssetDialogType, context?: AssetDialogContext) => void;
  closeDialog: () => void;
}

export const useAssetDialogStore = create<AssetDialogState>((set) => ({
  activeDialog: null,
  dialogContext: {},
  openDialog: (activeDialog, dialogContext = {}) => set({ activeDialog, dialogContext }),
  closeDialog: () => set({ activeDialog: null, dialogContext: {} }),
}));
